<template>
  <div
    class="overflow-y-auto"
    :style="{ height: 'calc(100vh - 4.5rem - 8rem - 3.5rem)' }"
  >
    <div v-if="fetchLoading" class="h-full grid items-center justify-center">
      <div class="blum-loader"></div>
    </div>
    <div
      v-else-if="!prospectActivityHistories.length"
      class="h-full grid items-center justify-center"
    >
      <BlTextBody2 text="There are no activiry histories for this prospect." />
    </div>
    <div v-else class="py-4 px-6">
      <BlActivity
        v-for="(activity, idx) in prospectActivityHistories"
        :key="activity.id"
        :activity="activity"
        :isFirst="idx === 0"
        :isLast="idx + 1 === prospectActivityHistories.length"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import BlTextBody2 from "../../../BlTextBody2.vue";
import BlActivity from "../../../BlActivity.vue";

export default {
  name: "ActivityHistoryTab",
  components: {
    BlTextBody2,
    BlActivity
  },
  props: {},
  data() {
    return {
      fetchLoading: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "prospectStage", "prospectActivityHistories"])
  },
  watch: {},
  mounted() {
    this.fetchLoading = true;
    this.fetchProspectActivityHistories();
  },
  methods: {
    ...mapActions(["getProspectActivityHistories"]),
    fetchProspectActivityHistories() {
      const data = { id: this.prospectStage.prospect.id };
      this.getProspectActivityHistories(data).then(({ success }) => {
        this.fetchLoading = false;
        // if (!success) return;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/modal/prospectPanel/ActivityHistoryTab.vue